<template>
  <b-card>
    <b-row>
      <b-col
        cols="12"
        md="6"
      >
        <h4 class="card-title mb-0 pt-50">
          Edit Exception</h4>
      </b-col>
      <b-col
        cols="12"
        md="6 ml-auto"
      >
        <div class="d-flex align-items-center justify-content-end">
          <b-button
            variant="outline-secondary"
            @click="back"
          >
            Back
          </b-button>
        </div>
      </b-col>
    </b-row>
    <hr>
    <validation-observer ref="simpleRules">
      <b-form>
        <app-timeline>
          <app-timeline-item class="pb-1">
            <b-row>
              <b-col
                cols="12"
                md="6"
                lg="4"
              >
                <dl class="row">
                  <dt class="col-sm-12 dt-text">
                    Parent Type
                  </dt>
                  <dd class="col-sm-12">
                    <span
                      class="form-control"
                      v-text="exception.parent_type"
                    />
                  </dd>
                </dl>
              </b-col>
              <b-col
                cols="12"
                md="6"
                lg="4"
              >
                <dl class="row">
                  <dt class="col-sm-12 dt-text">
                    Parent
                  </dt>
                  <dd class="col-sm-12">
                    <span
                      class="form-control"
                      v-text="exception.parent_name"
                    />
                  </dd>
                </dl>
              </b-col>
            </b-row>
            <b-row>
              <b-col
                cols="12"
                md="6"
                lg="4"
              >
                <b-form-group>
                  <label>Parent Level</label>
                  <div class="demo-inline-spacing">
                    <b-form-checkbox
                      v-model="exception.parent_level"
                      class="mt-50"
                      @change="checkYes"
                    >
                      Yes
                    </b-form-checkbox>
                    <b-form-checkbox
                      v-model="exception.parent_level_no"
                      class="mt-50"
                      @change="checkNo"
                    >
                      No
                    </b-form-checkbox>
                  </div>
                </b-form-group>
              </b-col>
              <b-col
                v-if="!exception.parent_level"
                cols="12"
                md="6"
                lg="4"
              >
                <b-form-group
                  id="month_year"
                >
                  <label>Select Month/Year</label>
                  <validation-provider
                    v-slot="{ errors }"
                    name="Select Month/Year"
                    rules="required"
                  >
                    <flat-pickr
                      v-model="month_year"
                      class="form-control"
                      :config="$store.state.monthConfig"
                      placeholder="MM-YYYY"
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>
            </b-row>
            <b-row>
              <b-col
                cols="12"
                md="6"
                lg="4"
                class="mb-1"
              >
                <b-form-checkbox
                  v-model="exception.is_bypass_invoice"
                >
                  Bypass Invoice
                </b-form-checkbox>
              </b-col>
              <b-col
                cols="12"
                md="6"
                lg="4"
                class="mb-1"
              >
                <b-form-checkbox
                  v-model="exception.is_bypass_timesheet"
                >
                  Bypass Timesheet
                </b-form-checkbox>
              </b-col>
            </b-row>
            <b-row>
              <b-col
                cols="12"
                md="6"
                lg="4"
              >
                <b-form-group>
                  <label>Exception Reason</label>
                  <validation-provider
                    v-slot="{ errors }"
                    name="Exception Reason"
                    rules="required"
                  >
                    <b-form-textarea
                      v-model="exception.reason"
                      rows="2"
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>
            </b-row>
          </app-timeline-item>

          <app-timeline-item
            v-show="exception.user_defined_fields.length !== 0"
            variant="info"
            class="pb-1"
          >
            <div class="d-flex flex-sm-row flex-column flex-wrap justify-content-between mb-1 mb-sm-0">
              <h6>User Defined Fields</h6>
            </div>
            <b-row>
              <b-col
                v-for="field in exception.user_defined_fields"
                :id="field.id"
                :key="field.id"
                cols="12"
                md="6"
                lg="4"
              >
                <b-form-group v-if="field.type.toLowerCase() === 'input'">
                  <label>{{ field.name }}</label>
                  <validation-provider
                    v-slot="{ errors }"
                    :name="field.name"
                    :rules="field.required ? 'required' : ''"
                  >
                    <b-form-input
                      v-model="field.value"
                      :state="errors.length > 0 ? false:null"
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
                <b-form-group v-if="field.type.toLowerCase() === 'dropdown'">
                  <label>{{ field.name }}</label>
                  <validation-provider
                    v-slot="{ errors }"
                    :name="field.name"
                    :rules="field.required ? 'required' : ''"
                  >
                    <v-select
                      v-model="field.value"
                      :options="field.options"
                      label="option"
                      :reduce="item => item.option"
                      :clearable="!field.required"
                      placeholder="Select"
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
                <b-form-group v-if="field.type.toLowerCase() === 'textarea'">
                  <label>{{ field.name }}</label>
                  <validation-provider
                    v-slot="{ errors }"
                    :name="field.name"
                    :rules="field.required ? 'required' : ''"
                  >
                    <b-form-textarea
                      v-model="field.value"
                      rows="2"
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>
            </b-row>
          </app-timeline-item>
        </app-timeline>
        <hr>

        <b-row class="mt-1">
          <b-col class="text-right">
            <b-button
              variant="primary"
              type="button"
              @click="submitForm"
            >
              Update Exception
            </b-button>
          </b-col>
        </b-row>

      </b-form>
    </validation-observer>
  </b-card>
</template>

<script>
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import vSelect from 'vue-select'
import {
  BCard, BRow, BCol, BForm, BFormGroup, BFormTextarea, BFormCheckbox, BButton, BFormInput,
} from 'bootstrap-vue'
import AppTimeline from '@core/components/app-timeline/AppTimeline.vue'
import AppTimelineItem from '@core/components/app-timeline/AppTimelineItem.vue'
import Ripple from 'vue-ripple-directive'
import {
  required,
} from '@validations'
import flatPickr from 'vue-flatpickr-component'
import monthSelectPlugin from 'flatpickr/dist/plugins/monthSelect/index'
import 'flatpickr/dist/plugins/monthSelect/style.css'
import Constants from '@/js/constant'
import moment from 'moment'
import Exception from '@/js/exceptions'

export default {
  name: 'ExceptionEdit',
  components: {
    BCard,
    AppTimeline,
    AppTimelineItem,
    BFormInput,
    ValidationProvider,
    ValidationObserver,
    BRow,
    BCol,
    BForm,
    BFormGroup,
    BFormTextarea,
    BFormCheckbox,
    BButton,
    vSelect,
    flatPickr,
  },
  directives: {
    Ripple,
  },
  setup() {
  },
  data() {
    return {
      required,
      exception: {
        parent_level: true,
        parent_level_no: false,
        is_bypass_timesheet: false,
        is_bypass_invoice: false,
        reason: '',
        user_defined_fields: [],
      },
      configs: {
        monthSelect: {
          plugins: [
            monthSelectPlugin({
              shorthand: true,
              dateFormat: 'M-Y',
              altFormat: 'F, Y',
            }),
          ],
        },
        start: {
          format: 'MMM-YYYY',
          useCurrent: false,
          showClear: false,
          showClose: false,
          minDate: moment('01-01-2000', 'MM-DD-YYYY'),
        },
      },
      url: null,
      types: [],
      employees: [],
      month_year: null,
    }
  },
  mounted() {
  },
  created() {
    Exception.getExceptionById(this, this.$route.params.id)
  },
  destroyed() {
  },
  methods: {
    submitForm() {
      this.$refs.simpleRules.validate().then(result => {
        if (result) {
          if (!this.exception.parent_level) {
            this.exception.month = Constants.getEprmMonthDateFromString(`${moment(this.month_year, 'MMM-YYYY').format('MM')}-01-${moment(this.month_year, 'MMM-YYYY').format('YYYY')}`)
          } else {
            this.exception.month = null
          }
          this.showLoading = true
          Exception.updateException(this, this.$route.params.id, this.exception)
        }
      })
    },
    checkYes() {
      this.exception.parent_level_no = !this.exception.parent_level
    },
    checkNo() {
      this.exception.parent_level = !this.exception.parent_level_no
    },
    setExceptionEmployees(employees) {
      this.employees = employees
    },
    exceptionUpdated(data) {
      this.$refs.showLoading = false
      this.back()
      this.$swal({
        title: 'Success!',
        text: data.return_message,
        icon: 'success',
        customClass: {
          confirmButton: 'btn btn-primary',
        },
        buttonsStyling: false,
      })
    },
    exceptionNotUpdated(message) {
      this.$refs.showLoading = false
      this.$swal({
        title: 'Error!',
        text: message,
        icon: 'error',
        customClass: {
          confirmButton: 'btn btn-primary',
        },
        buttonsStyling: false,
      })
    },
    setException(exception) {
      this.exception = exception
      this.month_year = exception.month
      this.exception.parent_level_no = !exception.parent_level
    },
    back() {
      this.$router.push('/human-resources/exceptions').catch(() => {})
    },
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
@import '@core/scss/vue/libs/vue-flatpicker.scss';
@import '@core/scss/vue/libs/vue-sweetalert.scss';
.repeater-form {
  transition: .35s height;
}
</style>
